import React from 'react';

import { Tooltip } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { scaleValue } from '@packages/utils/base.utils';

export type ScaledValueProps = {
  decimals?: number;
  showTooltip?: boolean;
  sizeLabels?: string[];
  base: number;
  value: number;
};

// TODO: Refactor with packages/dashboard/src/pages/telemetry/scaledValue/ScaledValue.tsx
/**
 * This class is typically not rendered directly, but is instead intended to be composed
 * (wrapped) by a scaling widget that includes the base and units (children).
 */
export const ScaledValue: React.FC<ScaledValueProps> = ({
  base,
  decimals = 0,
  showTooltip = true,
  value,
  sizeLabels,
}) => {
  const { t } = useTranslation();
  const scaled = scaleValue(value, base, decimals, t, sizeLabels);

  const scaledValue = `${scaled.num} ${scaled.suffix}`;

  if (scaled.suffix && showTooltip) {
    // number is scaled, wrap it with a tooltip of the raw value if requested
    return (
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span>{scaledValue}</span>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Tooltip.Text>{Number(value).toLocaleString()}</Tooltip.Text>
        </Tooltip.Content>
      </Tooltip.Root>
    );
  }

  return <span>{scaledValue}</span>;
};
